import React from 'react';
import { Button, makeStyles, createStyles } from '@material-ui/core';
import { theme } from './theme';

export type CommandType = 'device' | 'location';

export interface IAppButton {
	onClick: () => void;
	label: string;
	color: string;
	icon?: React.ReactNode;
	variant: 'text' | 'outlined' | 'contained';
	style?: any;
}

export default function AppButton(props: IAppButton) {
	const useStyles = makeStyles(() =>
		createStyles({
			button: {
				margin: '5px 0 5px -10px',
				minWidth: '110% !important',
			},
			text: {
				margin: '2px 0 0 5px',
				padding: 0,
			},
			outlinedText: {
				color: props.color,
				'&:hover': {
					backgroundColor: props.color, //alpha(props.color, theme.palette.action.hoverOpacity),
					'@media (hover: none)': {
						backgroundColor: 'transparent',
					},
				},
			},
			contained: {
				background: props.color,
				borderRadius: '10px',
				'&:hover': {
					background: props.color, //alpha(props.color, 1),
				},
				'&$disabled': {
					border: `1px solid ${theme.palette.action.disabled}`,
				},
			},
			outlined: {
				border: `1px solid ${props.color}`, //${alpha(props.color, 1)}`,
				'&:hover': {
					border: `1px solid ${props.color}`,
				},
				'&$disabled': {
					border: `1px solid ${theme.palette.action.disabled}`,
				},
			},
		})
	);
	const classes = useStyles(props);
	const { onClick, label, variant, style: textStyle } = props;

	return (
		<>
			<Button
				variant={variant}
				color='inherit'
				onClick={() => {
					onClick();
				}}
				className={[
					variant === 'outlined' ? classes.outlinedText : '',
					variant === 'outlined' ? classes.outlined : classes.contained,
					classes.button,
				].join(' ')}
				style={textStyle}
			>
				{props.icon}
				<p className={classes.text}>{label}</p>
			</Button>
		</>
	);
}
